module.exports = __webpack_public_path__ + "img/network_error.9b3396f7.svg";